import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { AgentLoanOfficers } from '~/sections/agents/profile/types';

type IndexParams = {
  id: string;
  page: number;
  sort_field: string;
  order: Order;
  period: Period;
  export_team_data: boolean;
};

type IndexResponse = {
  data: AgentLoanOfficers;
};

export const index = async (params: IndexParams) => {
  const { id, sort_field, order, ...restParams } = params;

  return apiClient.get<IndexResponse>(
    `/realtors/${id}/loan_officers?sort[field]=${sort_field}&sort[order]=${order}`,
    { params: restParams }
  );
};
